import type { TranslationDictionary } from "./types";

export const JA_DICTIONARY: TranslationDictionary = {
    "app.newTask": "新規",
    "app.newTaskAria": "新規チャット",
    "sidebar.searchPlaceholder": "プロンプトまたはタスク ID を検索",
    "sidebar.filters": "タスクフィルター",
    "sidebar.allRatios": "すべての比率",
    "sidebar.allOrientations": "すべての方向",
    "sidebar.allModes": "すべてのモード",
    "sidebar.allResolutions": "すべての解像度",
    "sidebar.activeTasks": "アクティブなタスク",
    "sidebar.topAnchors": "上部の時間ナビゲーション",
    "sidebar.bottomAnchors": "下部の時間ナビゲーション",
    "sidebar.resize": "サイドバーのサイズを変更する",
    "batch.selected": "0 個が選択されました",
    "batch.selectedCount": "{count} 件を選択中",
    "batch.archivedCount": "{count} 件のチャットをアーカイブしました",
    "batch.archiveFailed": "バッチ アーカイブに失敗しました",
    "batch.runningCannotDeleteSelected": "選択したチャットは実行中のため削除できません",
    "batch.deleteTitle": "{count} 件のチャットを削除しますか？",
    "batch.deleteMessage": "これにより、ローカルの画像ファイルも削除されます。",
    "batch.deleteSkippedDetail": "実行中のタスク {count} 件は保持されます",
    "batch.deleteSkippedSuffix": "、実行中のタスク {count} 件は削除されませんでした",
    "batch.deletedCount": "{count} 件のチャットを削除しました{skipped}",
    "batch.deleteFailed": "一括削除に失敗しました",
    "action.archive": "アーカイブ",
    "action.delete": "削除",
    "action.cancel": "キャンセル",
    "action.edit": "編集",
    "action.clear": "クリア",
    "action.paste": "貼り付け",
    "action.find": "検索",
    "action.replace": "置換",
    "action.close": "閉じる",
    "action.confirm": "確認",
    "action.confirmQuestion": "アクションを確認しますか?",
    "action.refresh": "更新",
    "action.save": "保存",
    "action.add": "追加",
    "action.new": "新規",
    "action.import": "インポート",
    "action.export": "エクスポート",
    "queue.empty": "キューなし",
    "queue.emptyAria": "キューのステータス: キューに入れられたタスクはありません",
    "queue.jumpTitle": "アクティブなタスクにジャンプします",
    "queue.emptyTitle": "キューに入れられたタスクはありません",
    "queue.channel": "チャネル {count}",
    "queue.availableChannels": "利用可能なチャネル{usable}/{total}",
    "queue.dispatching": "スケジュール中 · 待機 {waiting}",
    "queue.runningWaiting": "実行中 {running} · 待機 {waiting}",
    "queue.statusLabel": "キューのステータス:{text}·{channelText}。クリックするとアクティブなタスクにジャンプします",
    "queue.runningActions": "タスクキューアクションを実行しています",
    "queue.waitingActions": "待機中のタスクキューのアクション",
    "queue.cancelRunning": "キャンセル",
    "queue.cancelRunningTitle": "実行中のタスクをキャンセルします",
    "queue.dragWaiting": "ドラッグして待機中のタスクの順序を変更します",
    "queue.dragSort": "ドラッグして並べ替えます",
    "queue.moveUp": "上",
    "queue.moveUpTitle": "待機中のタスクを上に移動",
    "queue.moveDown": "下へ",
    "queue.moveDownTitle": "待機中のタスクを下に移動します",
    "queue.promote": "先頭へ",
    "queue.promoteTitle": "待機中のタスクを先頭に移動",
    "queue.promoteFailed": "先頭への移動に失敗しました",
    "queue.deleteWaitingShort": "削除",
    "queue.deleteWaitingTitle": "待機中のタスクを削除",
    "queue.deleteWaitingTitleConfirm": "待機中のタスクを削除しますか?",
    "queue.deleteWaitingMessage": "キューと履歴リストから削除されます。",
    "queue.deleteQueuedFailed": "キューに入れられたタスクの削除に失敗しました",
    "queue.queuedDeleted": "キューに登録されたタスクが削除されました",
    "queue.cancelRunningConfirm": "タスクをキャンセル",
    "queue.cancelRunningTitleConfirm": "実行中のタスクをキャンセルしますか?",
    "queue.cancelRunningMessage": "現在のタスクは停止します。履歴は残ります。",
    "queue.cancelRunningFailed": "タスクのキャンセルに失敗しました",
    "queue.runningCancelled": "タスクがキャンセルされました",
    "queue.reorderFailed": "キューの並べ替えに失敗しました",
    "queue.realtimeUpdateFailed": "ライブステータスを更新できませんでした",
    "queue.realtimeDisconnected": "ライブ ステータス接続が失われました。回復するにはページを更新してください。",
    "queue.readFailed": "キューのロードに失敗しました",
    "status.waiting": "タスク待機中",
    "status.shownActiveTasks": "アクティブなタスクを表示しています",
    "status.jsonCopied": "JSONをコピーしました",
    "taskStatus.submitting": "送信中",
    "taskStatus.running": "生成中",
    "taskStatus.runningWithElapsed": "生成中 ·{elapsed}",
    "taskStatus.completed": "完了",
    "taskStatus.partialFailed": "部分的に失敗しました",
    "taskStatus.failed": "失敗しました",
    "taskStatus.queued": "キューに登録されました",
    "taskStatus.unknown": "不明なステータス",
    "taskStatus.task": "タスク",
    "taskStatus.connectionInterrupted": "接続が中断されました",
    "taskStatus.lastFailed": "最後に失敗しました",
    "taskStatus.waitingRetry": "{reason}、再試行を待機中 ({attempt}/{max}を試行)",
    "taskStatus.retrying": "{reason}、再試行中 ({attempt}/{max}を試行)",
    "taskStatus.nonRetryableAttempt": "{attempt}/{max}を試行します。再試行できません",
    "taskStatus.manualRetryAvailable": "停止しました。失敗したイメージは手動で再試行できます",
    "taskStatus.waitingRetryShort": "再試行待ち",
    "taskStatus.retryingShort": "再試行中",
    "taskStatus.nonRetryableShort": "再試行不可",
    "taskStatus.manualRetryShort": "手動再試行",
    "taskStatus.stoppedShort": "停止",
    "taskStatus.runtime": "期間{duration}",
    "taskStatus.runtimeCompleted": "期間{duration}· 完了{time}",
    "taskStatus.completedAt": "完了{time}",
    "taskCard.count": "画像 {count} 枚",
    "taskCard.successCount": "成功 {count}",
    "taskCard.failedCount": "失敗 {count}",
    "taskCard.runningCount": "生成中 {count}",
    "taskCard.waitingCount": "待機中 {count}",
    "taskCard.textToImageThumb": "テキストから画像へのタスクのサムネイル",
    "taskCard.imageToImageThumb": "画像から画像へのタスクのサムネイル",
    "taskCard.failedThumb": "タスクが失敗しました",
    "taskCard.textBadge": "T",
    "taskMode.edit": "編集",
    "taskMode.generate": "生成",
    "document.generatingQueue": "キュー{total}を生成中",
    "document.queuedWaiting": "キュー内 · 待機 {count}",
    "runFeedback.editing": "編集中",
    "runFeedback.generating": "生成中",
    "runFeedback.status": "{action}、{elapsed}経過",
    "footer.archive": "アーカイブ",
    "footer.archiveCount": "アーカイブ {count}",
    "footer.historyLibrary": "履歴",
    "historyLibrary.openFull": "履歴ライブラリ全体を開く",
    "history.documentTitle": "履歴 - 阿泰生图",
    "history.back": "ジェネレーターに戻る",
    "history.title": "履歴",
    "history.loading": "読み込み中",
    "history.total": "{total}タスク ·{archived}がアーカイブされました",
    "history.search": "検索",
    "history.searchPlaceholder": "プロンプトまたはタスク ID を検索",
    "history.clear": "クリア",
    "history.type": "種類",
    "history.allTypes": "すべての種類",
    "history.type.textToImage": "テキストから画像",
    "history.type.imageToImage": "画像から画像",
    "history.month": "月",
    "history.status": "ステータス",
    "history.promptMode": "プロンプト処理",
    "history.size": "サイズ",
    "history.quality": "品質",
    "history.ratio": "比率",
    "history.orientation": "方向",
    "history.backend": "バックエンド",
    "history.provider": "プロバイダー",
    "history.archived": "アーカイブ済み",
    "history.all": "すべて",
    "history.allMonths": "すべての月",
    "history.allStatuses": "すべてのステータス",
    "history.allPromptModes": "すべてのモード",
    "history.allSizes": "すべてのサイズ",
    "history.allQualities": "すべての品質",
    "history.allRatios": "すべての比率",
    "history.ratioOther": "その他",
    "history.allOrientations": "すべての方向",
    "history.allBackends": "すべてのバックエンド",
    "history.allProviders": "すべてのプロバイダー",
    "history.unarchived": "未アーカイブ",
    "history.archivedOnly": "アーカイブされました",
    "history.tasksAria": "履歴タスク",
    "history.taskListTitle": "履歴タスク",
    "history.browseNewest": "最新のものから順に閲覧",
    "history.view": "表示",
    "history.grid": "グリッド",
    "history.list": "リスト",
    "history.sort": "並べ替え",
    "history.newest": "新しい順",
    "history.oldest": "古い順",
    "history.refresh": "更新",
    "history.selectedCount": "{count}タスクが選択されました",
    "history.confirmDelete": "削除の確認",
    "history.detail": "タスクの詳細",
    "history.detailTitle": "履歴タスク",
    "history.closeDetail": "タスクの詳細を閉じる",
    "history.resizeFilters": "フィルターサイドバーのサイズを変更",
    "history.resizeDetail": "詳細ペインのサイズを変更する",
    "history.detailEmpty": "詳細を表示するには履歴タスクを選択してください",
    "history.loadingDetail": "詳細を読み込み中...",
    "history.loadMore": "もっと読み込む",
    "history.loadingMore": "読み込み中...",
    "history.noMore": "これ以上のタスクはありません",
    "history.loadFailed": "ロードに失敗しました。更新するかスクロールを続けて再試行してください",
    "history.summaryFailed": "概要をロードできませんでした",
    "history.tasksFailed": "タスクのロードに失敗しました",
    "history.detailFailed": "詳細のロードに失敗しました",
    "history.noMatches": "一致するタスクはありません",
    "history.loadedCount": "{count} 件を読み込みました",
    "history.windowNotice": "表示されるリストは {count} 件のタスクに制限されています。上下にスクロールすると、必要な周辺タスクを復元できます。",
    "history.selectTask": "タスクの選択",
    "history.viewing": "閲覧中",
    "history.noPreview": "プレビュー画像がありません",
    "history.downloadAll": "ZIP をダウンロード",
    "history.downloadImage": "画像をダウンロード",
    "history.downloadSelected": "選択項目をダウンロード",
    "history.deleteUnselected": "未選択を削除",
    "history.confirmDeleteUnselected": "未選択の削除を確認",
    "history.selected": "選択済み",
    "history.select": "選択してください",
    "history.downloadIndex": "{index} をダウンロード",
    "history.addReference": "参照を追加",
    "history.outputActions": "結果画像のアクション",
    "history.inputReferences": "入力リファレンス",
    "history.inputReferenceIndex": "入力参照 {index}",
    "history.copyPrompt": "プロンプトをコピー",
    "history.copyPrompts": "プロンプトをコピー",
    "history.copyPromptShort": "コピー",
    "history.copyPromptPanel": "{title}をコピー",
    "history.copyOutputPromptPanel": "画像 {index} の改訂プロンプトをコピー",
    "history.copyTaskIds": "タスク ID をコピー",
    "history.reuseTask": "ジェネレーターで表示",
    "history.downloadTask": "ダウンロード",
    "history.downloadSelectedTasks": "バッチダウンロード",
    "history.contextMenuLabel": "履歴タスクのコンテキスト メニュー",
    "history.promptCopied": "プロンプトがコピーされました",
    "history.promptsCopied": "{count} 件のタスクからプロンプトをコピーしました",
    "history.taskIdsCopied": "{count} 件のタスク ID をコピーしました",
    "history.promptCopiedShort": "コピーしました",
    "history.promptCopyFailed": "プロンプトのコピーに失敗しました",
    "history.promptCopyFailedShort": "失敗しました",
    "history.noPrompt": "このタスクにはコピーするプロンプトがありません",
    "history.noPromptShort": "空",
    "history.downloadStarted": "ダウンロードが開始されました",
    "history.batchDownloadStarted": "{count} 件のタスクのダウンロードを開始しました",
    "history.noDownloadableOutputs": "ダウンロード可能な画像はありません",
    "history.confirmDeleteSelected": "選択した削除を確認します",
    "history.openPreview": "プレビューを開く",
    "history.closePreview": "プレビューを閉じる",
    "history.untitled": "無題",
    "history.promptCompare": "即時比較",
    "history.promptOriginal": "元のプロンプト",
    "history.promptSubmitted": "最適化されたプロンプト",
    "history.promptRevised": "修正結果",
    "history.outputRevisedPromptTitle": "画像 {index} の改訂プロンプト",
    "history.outputRevisedPromptNotice": "各画像には画像ごとの改訂プロンプトがあります。",
    "history.promptEmpty": "コンテンツがありません",
    "history.promptMode.strict": "忠実",
    "history.promptMode.original": "原文",
    "history.promptMode.off": "自動",
    "history.quality.high": "高",
    "history.quality.medium": "中",
    "history.quality.low": "低",
    "history.quality.auto": "自動",
    "footer.batch": "バッチ",
    "footer.storage": "ストレージ",
    "footer.apiStatus": "APIステータス: OK",
    "footer.version": "バージョン{version}",
    "footer.versionInfo": "バージョン情報",
    "footer.versionLoading": "バージョン...",
    "footer.updateBadge": "新しいバージョンが利用可能になりました",
    "footer.updateAvailable": "新しいバージョン{version}",
    "version.title": "バージョンとアップデート",
    "version.loading": "バージョンステータスの読み取り中",
    "version.current": "現在のバージョン",
    "version.latest": "最新バージョン",
    "version.source": "ランタイム",
    "version.sourcePortable": "ポータブルパッケージ",
    "version.sourceStandard": "Standard app",
    "version.sourceSource": "ソースのチェックアウト",
    "version.upToDate": "すでに最新バージョンを使用しています",
    "version.updateAvailable": "バージョン{version}が利用可能です。WebUIサーバー ウィンドウを閉じて、アップデーターを実行してアップグレードします。",
    "version.standardUpdateAvailable": "Version {version} is available. Updater-enabled macOS standard apps can install it from Check for Updates in the menu bar; this link remains the manual fallback.",
    "version.standardManualInstall": "Updater-enabled macOS standard apps support user-confirmed replacement; older macOS apps and Windows standard ZIP packages still update manually.",
    "version.noUpdater": "このランタイムはポータブル パッケージではないため、アップデーターを自動的に開始できません。",
    "version.openUpdater": "アップデーターの開始",
    "version.release": "リリースを見る",
    "version.updaterStarted": "アップデータを開始しました。現在の WebUI サーバーウィンドウを閉じ、アップデータの案内に従ってください。",
    "version.updaterFailed": "アップデーターを開始できませんでした。パッケージからアップデータ スクリプトを手動で実行します。",
    "version.historyTitle": "更新履歴",
    "version.historyEmpty": "更新履歴はありません",
    "version.currentBadge": "現在",
    "version.releaseDate": "{date}",
    "version.change.quick_gallery_picker": "Added a quick gallery modal picker with real-time search, multi-selection, and thumbnail optimizations.",
    "version.change.official_asset_library": "公式のロゴ、スローガン、ビジネスシグネチャ素材ライブラリを拡充し、複数ブランド、事業ライン、横型・縦型、反転版を追加しました。",
    "version.change.material_picker_modal": "素材選択をダイアログ化し、大きなサムネイル・カテゴリ・検索・複数選択での入力欄への追加に対応しました。",
    "version.change.brand_name": "製品名を「AI イノベーションスタジオ」に統一し、英語も AI Innovation Studio に更新しました。",
    "version.change.brand_templates": "選択可能なブランドテンプレートと、ロゴ・スローガンなどの自動合成を追加しました。",
    "version.change.brand_preview": "ブランド結果をプレビュー、履歴、拡大表示、ダウンロードで統一し、元画像への切り替えも維持しました。",
    "version.change.mobile_workspace": "モバイルのヘッダー、操作バー、素材サマリー、空のプレビューを圧縮し、制作フローを見やすくしました。",
    "version.change.task_center": "モバイルのタスクセンターをコンパクト化し、実行中・待機中タスクのバッジを追加しました。",
    "version.change.brand_launch": "Hengtai のブランド素材を備えたブランド版モバイル体験を初公開しました。",
    "version.change.core_workflow": "画像生成、タスクキュー、履歴、ギャラリー、設定の基本ワークフローを提供しました。",
    "notifications.title": "タスク通知",
    "notifications.unread": "通知、未読 {count} 件",
    "notifications.unreadSummary": "未読 {count} 件",
    "notifications.empty": "タスク通知がありません",
    "notifications.taskFailed": "タスクが失敗しました",
    "notifications.taskPartial": "タスクが部分的に完了しました",
    "notifications.taskCompleted": "タスクが完了しました",
    "notifications.generationFailed": "生成に失敗しました",
    "notifications.successCount": "成功 {count}",
    "notifications.resultAvailable": "結果が入手可能",
    "notifications.failedCount": "失敗 {count}",
    "notifications.systemUnsupported": "このブラウザはシステム通知をサポートしていません",
    "notifications.systemBlocked": "システム通知がブラウザーによってブロックされています。ブラウザの設定で有効にしてください。",
    "notifications.systemDenied": "システム通知が有効になっていません",
    "notifications.systemEnabled": "システム通知が有効になりました",
    "notifications.taskMissing": "タスクが存在しないか、削除されました",
    "theme.label": "テーマ",
    "theme.system": "システム",
    "theme.light": "ライト",
    "theme.dark": "ダーク",
    "language.label": "表示言語",
    "language.zh": "中",
    "language.zhCN": "簡体字中国語",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "認証元",
    "auth.checking": "認証を確認しています",
    "auth.missingCodexSession": "Codex セッションが検出されませんでした",
    "auth.switchFailed": "認証元の切り替えに失敗しました",
    "auth.sourceUnavailable": "{source}は利用できません",
    "auth.notActive": "アクティブではありません",
    "api.settings": "システム設定",
    "api.provider": "API プロバイダー",
    "imageInput.title": "画像入力",
    "imageInput.uploadAria": "画像とファイルをクリック、ドロップ、または貼り付け",
    "imageInput.uploadFull": "画像とファイルをクリック、ドロップ、または貼り付け",
    "imageInput.uploadCompact": "入力を追加",
    "imageInput.uploadSubtitle": "画像と Responses の参照ファイルに対応",
    "imageInput.recent": "最近のアップロード",
    "imageInput.recentBadge": "最近の",
    "imageInput.uploadBadge": "アップロード",
    "imageInput.addToGallery": "ギャラリーに追加",
    "imageInput.addToGalleryShort": "ギャラリー",
    "imageInput.removeImage": "画像を削除",
    "imageInput.editedBadge": "編集済み",
    "imageInput.editImage": "{name}を編集",
    "imageInput.deletedRecent": "最近のアップロードが削除されました",
    "imageInput.deletedGallery": "ギャラリー画像が削除されました",
    "recentAssets.defaultName": "最近のアップロード",
    "recentAssets.use": "{name}を使用してください",
    "recentAssets.delete": "{name}を削除",
    "recentAssets.deleteTitle": "最近のアップロードを削除しますか?",
    "recentAssets.deleteMessage": "これにより、最近のアップロードから画像が削除されます。現在画像入力として選択されている場合は、現在の入力から削除されます。この最近のアップロードを参照する履歴タスクは、その入力プレビューを失います。公開ギャラリーは影響を受けません。",
    "recentAssets.loadFailed": "最近のアップロードをロードできませんでした",
    "recentAssets.deleteFailed": "最近のアップロードを削除できませんでした",
    "recentAssets.deleted": "最近のアップロードが削除されました",
    "inputSource.uploadFallback": "アップロードされた画像",
    "inputSource.galleryFallback": "ギャラリー画像",
    "inputSource.focusPasteFallback": "{prefix}。画像入力に焦点が当てられています。{shortcut}を押して画像を貼り付けます。",
    "inputSource.pastedCount": "クリップボード画像 {count} 枚を貼り付けました",
    "inputSource.droppedCount": "ドロップした画像 {count} 枚を追加しました",
    "inputSource.dropImagesOnly": "画像ファイルのみをドロップします",
    "inputSource.clipboardUnsupported": "このブラウザはクリップボードを直接読み取ることができません",
    "inputSource.clipboardEmpty": "クリップボード画像が見つかりません",
    "inputSource.clipboardDenied": "ブラウザがクリップボードへの直接アクセスをブロックしました",
    "inputSource.clipboardReadFailed": "クリップボードの読み取りに失敗しました",
    "status.missingGalleryReference": "ギャラリーの参考画像が削除されました。生成する前に削除してください。",
    "status.missingRecentReference": "最近アップロードした参照画像が削除されました。生成する前に削除してください。",
    "status.emptyPrompt": "プロンプトを入力してください",
    "status.editNeedsImage": "編集モードには少なくとも 1 つの画像が必要です",
    "status.loadedTask": "ロードされたタスク{taskId}",
    "status.reusedTask": "ジェネレーターでタスク{taskId}を開きました",
    "status.loadingHistoryInputs": "過去の入力画像をロードしています...",
    "status.historyInputLoadFailed": "過去の入力画像のロードに失敗しました:{url}",
    "referenceCollector.alreadyStaged": "すでに一時参照に追加されています",
    "referenceCollector.staged": "参照画像 {count} 枚を一時追加しました",
    "referenceCollector.title": "一時参照 · {count}",
    "referenceCollector.addAll": "すべての参照を追加",
    "referenceCollector.itemFallback": "一時参照",
    "referenceCollector.remove": "一時参照を削除",
    "referenceCollector.cleared": "一時参照をクリアしました",
    "referenceCollector.added": "参照画像 {count} 枚を追加しました",
    "referenceCollector.addFailed": "一時参照を追加できませんでした",
    "referenceCollector.readFailed": "画像の読み取りに失敗しました:{status}",
    "gallery.quick": "クイックギャラリー",
    "gallery.current": "現在のカテゴリのギャラリー",
    "gallery.categories": "ギャラリーカテゴリ",
    "gallery.categoryPortrait": "の肖像画",
    "gallery.categoryCharacter": "キャラクター",
    "gallery.categoryProduct": "製品",
    "gallery.categoryPortraitRole": "ポートレートのリファレンス",
    "gallery.categoryCharacterRole": "文字リファレンス",
    "gallery.categoryProductRole": "製品リファレンス",
    "gallery.referenceRole": "参考画像",
    "gallery.manage": "ギャラリーの管理",
    "gallery.loadFailed": "ギャラリーのロードに失敗しました",
    "gallery.imageOrderUpdateFailed": "画像の順序を更新できませんでした",
    "gallery.imageOrderUpdated": "画像の順序が更新されました",
    "gallery.categoryName": "カテゴリ名",
    "gallery.categoryPromptRole": "プロンプトでの用途",
    "gallery.categorySave": "保存",
    "gallery.categoryDelete": "削除",
    "gallery.categoryLoadFailed": "カテゴリのロードに失敗しました",
    "gallery.categoryNameRequired": "カテゴリ名を入力してください",
    "gallery.categoryCreateFailed": "カテゴリを追加できませんでした",
    "gallery.categoryCreated": "カテゴリを追加しました",
    "gallery.categorySaveFailed": "カテゴリを保存できませんでした",
    "gallery.categorySaved": "カテゴリが保存されました",
    "gallery.categoryDeleteTitle": "ギャラリー カテゴリを削除しますか?",
    "gallery.categoryDeleteMessage": "このカテゴリの画像は別のカテゴリに移動します。ギャラリー画像は削除されません。",
    "gallery.categoryDeleteConfirm": "カテゴリを削除",
    "gallery.categoryDeleteFailed": "カテゴリを削除できませんでした",
    "gallery.categoryDeletedMigrated": "カテゴリ「{name}」が削除され、画像が移行されました",
    "gallery.categoryOrderUpdateFailed": "カテゴリの順序を更新できませんでした",
    "gallery.categoryOrderUpdated": "カテゴリの順序が更新されました",
    "gallery.categoryFallback": "ギャラリー カテゴリ",
    "gallery.imageFallback": "ギャラリー画像",
    "gallery.imageLoadFailed": "この画像をロードできませんでした",
    "gallery.editImageLoadFailed": "編集のためにこの画像をロードできませんでした",
    "gallery.cannotAddImage": "この画像はギャラリーに追加できません",
    "gallery.nameRequired": "ギャラリー名を入力してください",
    "gallery.saveFailed": "ギャラリー画像の保存に失敗しました",
    "gallery.savedAsReference": "ギャラリーに追加され、ギャラリー参照に切り替えられました",
    "gallery.renameImage": "ギャラリー画像の名前を変更",
    "gallery.moveToCategory": "カテゴリに移動",
    "gallery.categoryRequired": "ギャラリー カテゴリを選択してください",
    "gallery.promptNoteTitle": "ギャラリー参照メモ",
    "gallery.updateFailed": "ギャラリーを更新できませんでした",
    "gallery.selectImageFile": "画像ファイルを選択してください",
    "gallery.replaceImageFailed": "ギャラリー画像を置換できませんでした",
    "gallery.replacedImage": "「{name}」のソース画像を置き換えました",
    "gallery.deleteImageTitle": "ギャラリー画像を削除しますか?",
    "gallery.deleteImageMessage": "履歴タスク参照は削除済みとして表示されます。",
    "gallery.deleteFailed": "ギャラリー画像の削除に失敗しました",
    "gallery.deletedSuffix": "(削除済み)",
    "gallery.editImageLabel": "ギャラリー画像を編集",
    "gallery.fieldCategory": "カテゴリ",
    "gallery.fieldPromptNote": "参考ノート",
    "gallery.fieldName": "名前",
    "quickGallery.empty": "{category}画像はありません",
    "promptGallery.remove": "@{name}を削除",
    "prompt.title": "プロンプト",
    "prompt.editorLabel": "プロンプト",
    "prompt.placeholder": "生成または編集する画像を記述します。ギャラリー参照の場合は @、カラー コードの場合は #、プロンプト スニペットの場合は ~ と入力します。",
    "prompt.run": "生成を開始",
    "prompt.runEdit": "編集を開始",
    "prompt.runTitle": "生成 (Cmd+Enter)",
    "prompt.runEditTitle": "編集開始 (Cmd+Enter)",
    "prompt.findPanel": "プロンプトの検索と置換",
    "prompt.findText": "テキストを検索",
    "prompt.replaceWith": "と置き換えます",
    "prompt.findActions": "アクションの検索と置換",
    "prompt.countZero": "0件の一致",
    "prompt.matchCount": "{count} 件一致",
    "prompt.foundCount": "{count} 件の一致が見つかりました",
    "prompt.noMatch": "一致するテキストがありません",
    "prompt.replacedCount": "{count} 件の一致を置換しました",
    "prompt.closeFind": "検索と置換を閉じます",
    "prompt.recentTemplates": "最近のテンプレート",
    "prompt.manageTemplates": "テンプレートの管理",
    "promptModel.galleryHeader": "参考画像のメモ:",
    "promptModel.galleryInstruction": "- 参照画像 {number}: ギャラリー「{name}」、用途: {role}。プロンプト内の @{name} はこの画像を指します。{note}",
    "outputSettings.title": "出力設定",
    "output.lock.lock": "パラメータを固定",
    "output.lock.unlock": "固定を解除して編集",
    "output.lock.current": "現在の固定設定",
    "output.lock.task": "選択したタスクの設定",
    "output.lock.adoptTask": "このタスク設定を使用",
    "output.lock.frame": "画角",
    "output.lock.outputCount": "出力枚数",
    "output.lock.output": "出力",
"output.lock.search": "検索",
    "output.lock.call": "呼び出し",
    "output.lock.sheets": "枚",
    "output.lock.imageModel": "画像モデル",
    "output.lock.prompt": "プロンプト",
    "output.lock.fileFormat": "ファイル形式",
    "output.lock.taskHint": "選択したタスクの設定を表示中です。現在の固定設定は変更されません。使用してもシステムチャンネルは変更されません。",
    "output.lock.lockedHint": "設定は固定されています。右上の鍵アイコンで編集に戻れます。",
    "output.lock.enabled": "オン",
    "output.lock.disabled": "オフ",
    "output.mainModel": "メインモデル",
    "output.selectMainModel": "メインモデルを選択",
    "output.mainModelCustomForInput": "現在の入力にカスタム モデルを使用します",
    "output.apiDirect": "API直接",
    "output.apiToolModel": "API 画像生成モデルを使用",
    "output.mainModelUnused": "メイン モデルはこのリクエストには使用されません",
    "output.webSearch": "ウェブ検索",
    "output.webSearchToggle": "オン",
    "output.webSearchTitle": "まず Web を検索してから、この世代にそれを使用します。CodexおよびAPI応答のみ",
    "output.promptMode": "プロンプト処理",
    "output.modeOriginal": "原文",
    "output.modeStrict": "忠実",
    "output.modeCreative": "自動",
    "output.promptHelp": "プロンプト処理の説明を表示",
    "output.promptHelpTitle": "プロンプト処理",
    "output.promptHelp.responsesChannel": "Responses · メインモデルが関与",
    "output.promptHelp.imagesChannel": "Images · 直接生成",
    "output.promptHelp.responses.original": "原文をメインモデルに渡し、画像ツールでできる限りそのまま使うよう求めます。ただし revised prompt が生成される場合があります。",
    "output.promptHelp.responses.strict": "メインモデルによる整理や拡張を許可しつつ、被写体、文字、色、構図などの必須条件を保持します。",
    "output.promptHelp.responses.automatic": "追加制約を付けず、メインモデルが解釈・最適化してから画像ツールを呼び出します。",
    "output.promptHelp.images.original": "アプリ側のルールを追加せず、原文を画像 API に直接送信します。",
    "output.promptHelp.images.strict": "原文と保真ルールを一緒に送信し、すべての必須条件の保持を強調します。",
    "output.promptHelp.images.automatic": "画像 API の既定処理で送信し、ギャラリー参照など必要な説明は含めます。",
    "output.sizeMode": "サイズモード",
    "output.sizePreset": "プリセット",
    "output.sizeCustom": "カスタム",
    "output.orientation": "方向",
    "output.square": "正方形",
    "output.portrait": "の肖像画",
    "output.landscape": "風景",
    "output.resolution": "解像度",
    "output.pixelSize": "ピクセル サイズ",
    "output.width": "幅",
    "output.height": "高さ",
    "output.swapSize": "幅と高さを入れ替える",
    "output.customSizeHint": "ユニットpx· 16-3840 · 16 の倍数 · ≤3:1",
    "output.imageSizeUnavailable": "画像サイズが利用できません",
    "output.imageLoadFailed": "画像のロードに失敗しました",
    "output.customSizeRequired": "幅と高さを入力してください",
    "output.customSizeBounds": "幅と高さは 16-3840pxである必要があります",
    "output.customSizeMultiple": "幅と高さは 16 の倍数でなければなりません",
    "output.customSizeRatio": "長辺と短辺の比率は 3:1 を超えることはできません",
    "output.customSizePixels": "総ピクセル数は 655,360 ～ 8,294,400 である必要があります",
    "output.ratioLock": "レシオロック (オプション)",
    "output.customRatio": "カスタム アスペクト比",
    "output.ratioWidth": "W",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "最初の参照画像のアスペクト比を使用します",
    "output.useFirstImage": "画像より",
    "output.ratioHint": "フリーサイズの場合は空白のままにしておきます · 同期するには両方を入力します",
    "output.ratio": "比率",
    "output.quality": "品質",
    "output.qualityAuto": "自動",
    "output.qualityLow": "低",
    "output.qualityMedium": "中",
    "output.qualityHigh": "高",
    "output.quantity": "カウント",
    "output.pixelPreview": "出力ピクセル: 1024 x 1024px",
    "output.pixelPreviewValue": "出力ピクセル:{value}",
    "output.pixelPreviewAuto": "出力ピクセル: 自動 (OpenAI が自動的に選択します)",
    "output.format": "形式",
    "output.compression": "圧縮",
    "output.moderation": "節度",
    "preview.title": "プレビュー",
    "preview.selectedZero": "0 個が選択されました",
    "preview.selectedCount": "{selected}/{total}を選択しました",
    "preview.downloadSelected": "選択項目をダウンロード",
    "preview.deleteUnselected": "未選択を削除",
    "preview.downloadAll": "ZIP をダウンロード",
    "preview.empty": "画像はまだありません",
    "preview.taskFailed": "タスクが失敗しました",
    "preview.partialFailed": "一部の画像が失敗しました",
    "preview.failedOutput": "画像{index}が失敗しました",
    "preview.progressLine": "完了{generated}/{total}· 経過{elapsed}",
    "preview.failureLine": "完了{generated}/{total}· 失敗{failed}",
    "preview.elapsedLine": "{elapsed}が経過しました",
    "preview.lastError": "最後のエラー:{error}",
    "preview.continueGenerating": "継続世代",
    "preview.waitingContinue": "続行を待っています",
    "preview.retryFailed": "失敗したイメージを再試行します",
    "preview.acceptSuccesses": "成功した結果を受け入れる",
    "preview.generateMode": "世代",
    "preview.editMode": "編集",
    "preview.runningTitle": "{mode}実行中",
    "preview.submittingTitle": "タスクを送信中",
    "preview.queuedTitle": "タスクがキューに登録されました",
    "preview.submittingDetail": "入力を保存し、タスクをキューに追加します。生成が自動的に開始されます。",
    "preview.queuedDetail": "タスクはキュー内にあり、使用可能なチャネルを待っています。",
    "preview.featured": "選択済み",
    "preview.addFeatured": "結果の選択",
    "preview.selectedFeatured": "選択済み",
    "preview.removeFeatured": "結果の選択を解除",
    "preview.selectionAdded": "結果が選択されました",
    "preview.selectionRemoved": "結果の選択が解除されました",
    "preview.selectionUpdateFailed": "選択内容を更新できませんでした",
    "preview.noUnselectedOutputs": "削除する未選択の画像はありません",
    "preview.deleteUnselectedTitle": "未選択の画像を削除しますか?",
    "preview.deleteUnselectedMessage": "これにより、このタスクで選択されていない結果のローカル画像ファイルが削除されます。",
    "preview.deleteUnselectedDetail": "{selected}を保持し、{deleted}を削除",
    "preview.deleteUnselectedFailed": "未選択の画像を削除できませんでした",
    "preview.deleteUnselectedDone": "選択されていない画像が削除されました",
    "preview.addReference": "参照を追加",
    "preview.stage": "一時追加",
    "preview.stageReference": "一時参照に追加",
    "preview.prompt": "プロンプト",
    "preview.download": "ダウンロード",
    "preview.downloadImage": "この画像をダウンロード",
    "lightbox.label": "画像プレビュー",
    "lightbox.close": "プレビューを閉じる",
    "lightbox.previous": "前の画像",
    "lightbox.next": "次の画像",
    "promptPopover.title": "即時比較",
    "promptPopover.summary": "オリジナル{original}· 最適化された{optimized}",
    "promptPopover.original": "元のプロンプト",
    "promptPopover.optimized": "最適化されたプロンプト",
    "promptPopover.charCount": "{count}文字",
    "promptPopover.empty": "なし",
    "promptPopover.notReturned": "返品されませんでした",
    "promptPopover.noOptimized": "最適化されたプロンプトが返されませんでした",
    "promptPopover.submitted": "送信されたプロンプトを表示する",
    "promptPopover.close": "プロンプト比較を閉じる",
    "promptPopover.copyOptimized": "最適化プロンプトをコピー",
    "promptPopover.copied": "コピーしました",
    "taskContext.menuLabel": "タスクのコンテキスト メニュー",
    "taskContext.view": "タスクの表示",
    "taskContext.copyId": "タスク ID をコピー",
    "taskContext.copyPrompt": "プロンプトをコピー",
    "taskContext.revealOutput": "出力フォルダーを開く",
    "taskContext.archive": "アーカイブタスク",
    "taskContext.delete": "タスクを削除します",
    "taskContext.idCopied": "タスクIDがコピーされました",
    "taskContext.promptCopied": "プロンプトがコピーされました",
    "taskContext.noPrompt": "このタスクにはコピーするプロンプトがありません",
    "taskContext.revealFailed": "出力フォルダーを開けませんでした",
    "taskContext.revealOpened": "出力フォルダーが開きました",
    "taskContext.actionFailed": "タスクアクションが失敗しました",
    "taskActions.group": "タスクのアクション",
    "taskActions.deleteTitle": "タスクを削除しますか?",
    "taskActions.deleteMessage": "これにより、ローカルの画像ファイルも削除されます。",
    "taskActions.runningCannotDelete": "実行中のタスクは削除できません",
    "taskActions.updated": "タスクのステータスが更新されました",
    "taskActions.archived": "チャットがアーカイブされました",
    "taskActions.archiveFailed": "アーカイブに失敗しました",
    "taskActions.deleted": "タスクが削除されました",
    "taskActions.deleteFailed": "削除に失敗しました",
    "taskActions.noRetryableFailedImages": "このタスクには再試行する失敗したイメージがありません",
    "taskActions.retryFailedOutputsFailed": "失敗したイメージの再試行に失敗しました",
    "taskActions.requeuedFailedImages": "失敗したイメージが再度キューに追加されました",
    "taskActions.noAcceptableSuccessImages": "このタスクには受け入れられる成功したイメージがありません",
    "taskActions.acceptSuccessesFailed": "成功した結果を受け入れることができませんでした",
    "taskActions.acceptedSuccesses": "成功した結果が受け入れられました",
    "taskActions.viewedUpdateFailed": "読み取り状態の更新に失敗しました",
    "taskActions.failedFallback": "タスクが失敗しました",
    "taskList.empty": "履歴はまだありません",
    "taskList.selectSession": "チャットを選択",
    "taskList.unreadUpdate": "未読の更新",
    "taskList.viewing": "閲覧中",
    "taskDerived.usageLimited": "使用制限あり",
    "taskSubmit.requestFailed": "リクエストが失敗しました",
    "taskSubmit.queued": "タスクがキューに追加されました",
    "taskSubmit.timeout": "バックエンドが応答する前にタスクの送信がタイムアウトになりました。キューを更新してキューが追加されたかどうかを確認し、再試行するかどうかを決定します。",
    "taskSubmit.failed": "タスクの送信に失敗しました",
    "templates.title": "プロンプトテンプレート",
    "templates.summary": "ローカル テンプレート ライブラリ",
    "templates.availableCount": "利用可能なテンプレート {count} 件",
    "templates.noMatch": "一致するテンプレートがありません",
    "templates.empty": "テンプレートはありません",
    "templates.favoriteBadge": "お気に入り",
    "templates.usageCount": "使用回数 {count}",
    "templates.back": "戻る",
    "templates.edit": "編集",
    "templates.copy": "コピー",
    "templates.insert": "インサート",
    "templates.formTitle": "タイトル",
    "templates.formShortTitle": "短いタイトル",
    "templates.formCategory": "カテゴリ",
    "templates.formTags": "タグ",
    "templates.formThumbnail": "サムネイル",
    "templates.formContent": "コンテンツ",
    "templates.formNotes": "注記",
    "templates.formFavorite": "お気に入り",
    "templates.thumbnailClear": "クリア",
    "templates.thumbnailNone": "何も選択されていません",
    "templates.thumbnailEmpty": "履歴のサムネイルがありません",
    "templates.newCategory": "新しいカテゴリ",
    "templates.search": "テンプレート、タグ、またはコンテンツを検索します",
    "templates.filter": "テンプレート フィルター",
    "templates.all": "すべて",
    "templates.categoryCommon": "共通",
    "templates.categoryPortrait": "の肖像画",
    "templates.categoryProduct": "製品",
    "templates.categoryRepair": "修理",
    "templates.categoryPoster": "ポスター",
    "templates.categoryEcommerce": "電子商取引",
    "templates.favorite": "お気に入り",
    "templates.recent": "最近の",
    "templates.category": "カテゴリ",
    "templates.loadFailed": "プロンプト テンプレートのロードに失敗しました",
    "templates.useStateUpdateFailed": "プロンプト テンプレートの使用状態を更新できませんでした",
    "templates.copied": "プロンプト テンプレートがコピーされました",
    "templates.copyFailed": "プロンプト テンプレートのコピーに失敗しました",
    "templates.history": "履歴",
    "templates.saveFailed": "プロンプト テンプレートを保存できませんでした",
    "templates.saved": "プロンプト テンプレートが保存されました",
    "templates.deleteFailed": "プロンプト テンプレートの削除に失敗しました",
    "templates.deleted": "プロンプト テンプレートが削除されました",
    "templates.categoryAddFailed": "テンプレート カテゴリを追加できませんでした",
    "templates.categoryAdded": "テンプレート カテゴリが追加されました",
    "templates.categorySaveFailed": "テンプレート カテゴリの保存に失敗しました",
    "templates.categorySaved": "テンプレート カテゴリが保存されました",
    "templates.categoryDeleteFailed": "テンプレート カテゴリの削除に失敗しました",
    "templates.categoryDeleted": "テンプレート カテゴリが削除されました",
    "templates.importFailed": "テンプレート パックのインポートに失敗しました",
    "templates.importedCount": "テンプレート {count} 件をインポートしました",
    "templates.exportFailed": "テンプレート パックのエクスポートに失敗しました",
    "templates.exported": "テンプレート パックがエクスポートされました",
    "snippets.suggestLabel": "プロンプト スニペット ピッカー",
    "snippets.saveSelection": "保存",
    "snippets.saveSelectionLabel": "選択したテキストをプロンプト スニペットとして保存します",
    "snippets.popoverLabel": "プロンプト スニペット",
    "snippets.defaultCategory": "共通",
    "snippets.loadFailed": "プロンプト スニペットの読み込みに失敗しました",
    "snippets.remove": "~{tag}を削除",
    "snippets.expand": "展開する",
    "snippets.edit": "編集",
    "snippets.close": "閉じる",
    "snippets.editTitle": "スニペットを編集",
    "snippets.saveTitle": "スニペットを保存",
    "snippets.shortTag": "短いタグ",
    "snippets.title": "タイトル",
    "snippets.category": "カテゴリ",
    "snippets.content": "コンテンツ",
    "snippets.titlePlaceholder": "デフォルトで短いタグを使用します",
    "snippets.cancel": "キャンセル",
    "snippets.save": "保存",
    "snippets.saveFailed": "プロンプト スニペットを保存できませんでした",
    "snippets.saved": "プロンプト スニペットが保存されました",
    "snippets.defaultTag": "共通スニペット",
    "colors.white": "ホワイト",
    "colors.black": "ブラック",
    "colors.warmBeige": "ウォームベージュ",
    "colors.lightGreen": "ライトグリーン",
    "colors.brandGreen": "ブランドグリーン",
    "colors.peachOrange": "ピーチオレンジ",
    "colors.lightBlue": "ライトブルー",
    "colors.lightPink": "ライトピンク",
    "colors.loadFailed": "カラー設定のロードに失敗しました",
    "colors.saveFailed": "カラー設定を保存できませんでした",
    "colors.importFailed": "カラー設定のインポートに失敗しました",
    "colors.importedCount": "色 {count} 件をインポートしました",
    "colors.recentSaveFailed": "最近の色を保存できませんでした",
    "colors.favoriteSaveFailed": "お気に入りの色を保存できませんでした",
    "colors.favoriteDeleteFailed": "お気に入りの色の削除に失敗しました",
    "colors.update": "更新",
    "colors.insert": "インサート",
    "colors.pick": "色を選択してください",
    "colors.pickShort": "選択してください",
    "colors.hexValue": "カラー値",
    "colors.pendingUpdate": "色が変更されました。 「更新」をクリックして適用します。",
    "colors.save": "保存",
    "colors.exportPs": "エクスポート",
    "colors.importPs": "インポート",
    "colors.done": "完了",
    "colors.manage": "管理",
    "colors.favorites": "好きな色",
    "colors.recent": "最近の色",
    "colors.recentLabel": "最近の",
    "colors.deleteFavorite": "お気に入りの色を削除{name}",
    "colors.modify": "カラーを編集",
    "colors.modifyValue": "カラーを編集{value}",
    "colors.removeValue": "カラーを削除{value}",
    "taskGroup.today": "今日",
    "taskGroup.yesterday": "昨日",
    "taskGroup.last7": "過去 7 日間",
    "taskGroup.older": "年上",
    "taskGroup.searchResults": "の検索結果",
    "taskGroup.active": "アクティブ",
    "taskGroup.running": "実行中",
    "taskGroup.waiting": "待っています",
    "taskGroup.dispatchPending": "利用可能なチャネルを割り当てています...",
    "taskGroup.expand": "{label}を展開",
    "taskGroup.collapse": "崩壊{label}",
    "taskGroup.buttonLabel": "{label}、{count}タスク",
    "archive.title": "アーカイブ",
    "archive.empty": "アーカイブされたチャットはありません",
    "archive.count": "アーカイブ済みチャット {count} 件",
    "archive.restore": "復元",
    "archive.archiveFailed": "アーカイブに失敗しました",
    "archive.restoreFailed": "復元に失敗しました",
    "archive.restored": "チャットが復元されました",
    "archive.archiving": "アーカイブ中...",
    "archive.restoring": "復元中...",
    "archive.deleting": "削除しています...",
    "archive.restoredCount": "{count}タスクを復元しました",
    "settings.title": "ストレージ設定",
    "settings.status": "ストレージパスの保存後、WebUI の再起動で反映されます",
    "settings.inputRoot": "入力フォルダー",
    "settings.outputRoot": "出力フォルダー",
    "settings.galleryRoot": "共有ギャラリーフォルダー",
    "settings.sourceDataRoot": "ソースデータフォルダー",
    "settings.language": "表示言語",
    "settings.languageCopy": "初回起動時はブラウザーの言語設定に合わせます。手動で選択すると、その設定を記憶します。",
    "settings.notificationsCopy": "タスクの完了または失敗時に通知します。システム通知は手動で有効にする必要があります。",
    "settings.inAppNotification": "アプリ内通知",
    "settings.systemNotification": "システム通知",
    "settings.save": "設定を保存",
    "settings.loadFailed": "設定の読み込みに失敗しました",
    "settings.saveFailed": "設定の保存に失敗しました",
    "settings.savedRestart": "ストレージ設定を保存しました。WebUI を再起動すると反映されます。",
    "settings.saved": "保存しました",
    "settings.savedRestartStatus": "ストレージ設定を保存しました。WebUI を再起動すると反映されます。",
    "systemSettings.title": "システム設定",
    "systemSettings.tabsLabel": "システム設定セクション",
    "systemSettings.apiTab": "API設定",
    "systemSettings.codexTab": "Codexチャネル",
    "systemSettings.languageTab": "言語 / Language",
    "systemSettings.storageTab": "ストレージと通知",
    "languageSettings.instantStatus": "言語の変更はすぐに反映されます",
    "apiSettings.title": "API設定",
    "apiSettings.status": "保存した設定は API モードにすぐ反映されます",
    "apiSettings.codexMode": "Codexチャンネル",
    "apiSettings.codexImages": "画像",
    "apiSettings.codexResponses": "応答",
    "apiSettings.providers": "API プロバイダー",
    "apiSettings.searchProviders": "プロバイダー名を検索",
    "apiSettings.noProviderSearchResults": "一致するプロバイダーはありません",
    "apiSettings.providerCount": "プロバイダー {count} 件",
    "apiSettings.provider": "プロバイダー",
    "apiSettings.providerName": "プロバイダー名",
    "apiSettings.actualRequest": "実際のリクエスト",
    "apiSettings.newProviderAction": "プロバイダーを新規作成",
    "apiSettings.copyProvider": "コピー",
    "apiSettings.copyProviderName": "{name} をコピー",
    "apiSettings.copyProviderStatus": "保存済みのキーを含めてプロバイダーをコピーしました。保存する前に、名前やモデルを編集するか、キーを置き換えてください。",
    "apiSettings.copyProviderWithoutKeyStatus": "プロバイダーをコピーしました。保存する前に、名前やモデルを編集するか、API Key を追加してください。",
    "apiSettings.sortProviders": "並べ替え",
    "apiSettings.finishSortProviders": "完了",
    "apiSettings.sortProviderModeStatus": "プロバイダーの並べ替え",
    "apiSettings.sortProviderStatus": "プロバイダーの順序が変更されました。自動保存中...",
    "apiSettings.moveProviderUp": "上",
    "apiSettings.moveProviderDown": "下へ",
    "apiSettings.moveProviderUpAria": "{provider}を上に移動",
    "apiSettings.moveProviderDownAria": "{provider}を下に移動",
    "apiSettings.mode": "呼び出し方式",
    "apiSettings.images": "Image APIに直接接続",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "直結",
    "apiSettings.imageModel": "画像生成モデル",
    "apiSettings.concurrency": "同時実行上限",
    "apiSettings.concurrencyShort": "同時実行",
    "apiSettings.advancedSettings": "詳細設定",
    "apiSettings.concurrencyValue": "同時実行性{concurrency}",
    "apiSettings.keySaved": "API Keyが保存されました",
    "apiSettings.keyNotSet": "API Keyが設定されていません",
    "apiSettings.showApiKey": "APIキーを表示",
    "apiSettings.hideApiKey": "APIキーを隠す",
    "apiSettings.editProvider": "プロバイダーを編集",
    "apiSettings.newProviderTitle": "新しいプロバイダー",
    "apiSettings.editHint": "「プロバイダーを保存」を押すまで、この編集はバックエンドに書き込まれません。キャンセルすると破棄されます。",
    "apiSettings.finishEditFirst": "まず現在のプロバイダー編集を保存またはキャンセルしてください",
    "apiSettings.newDraftStatus": "プロバイダーを作成中です。反映するにはプロバイダーを保存してください。",
    "apiSettings.editDraftStatus": "プロバイダーを編集中です。反映するにはプロバイダーを保存してください。",
    "apiSettings.cancelEdit": "編集をキャンセル",
    "apiSettings.saveProvider": "プロバイダーを保存",
    "apiSettings.saveSelection": "現在の選択を保存",
    "apiSettings.deleteProviderTitle": "プロバイダーを削除しますか？",
    "apiSettings.deleteProviderMessage": "「{provider}」を削除しますか?",
    "apiSettings.deleteProviderDetail": "プロバイダー リストから削除し、バックエンドへ自動保存します。",
    "apiSettings.deleteProviderStatus": "プロバイダーが削除されました。自動保存中...",
    "apiSettings.save": "API設定を保存",
    "apiSettings.loadFailed": "API設定のロードに失敗しました",
    "apiSettings.savedKeyPlaceholder": "API Keyはバックエンドに保存されます。新しいキーを入力して置き換えます。",
    "apiSettings.newProvider": "新しいプロバイダー",
    "apiSettings.saving": "保存中...",
    "apiSettings.savingStatus": "API設定を保存しています...",
    "apiSettings.autoSaving": "自動保存中...",
    "apiSettings.autoSaved": "自動保存済み",
    "apiSettings.saveFailed": "API設定を保存できませんでした",
    "apiSettings.savedSummary": "保存済み · Codex {codex} · API {provider} · {mode} · {model} · 同時実行 {concurrency}",
    "apiSettings.savedShort": "保存しました",
    "apiSettings.savedStatus": "API設定が保存されました",
    "apiSettings.saveFailedShort": "保存に失敗しました",
    "codexSettings.title": "Codexチャネル",
    "codexSettings.status": "ローカルCodexサインインの生成チャネルを選択します",
    "codexSettings.notesLabel": "Codexチャネルの説明",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "サイズ、品質、編集パラメータを直接渡すためのデフォルトのチャネル。",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "Web 検索ツールを必要とするワークフローの互換性チャネル。",
    "codexSettings.current": "使用中",
    "codexSettings.save": "Codexチャネルを保存",
    "codexSettings.saveMode": "{mode}を保存",
    "imageEditor.title": "入力画像の編集",
    "imageEditor.promptHint": "画像内の手書きの矢印やマークは単なる指示です。それらを最終イメージに残さないでください。",
    "imageEditor.inputFallback": "入力画像",
    "imageEditor.openFailed": "この画像を編集のために開くことができませんでした",
    "imageEditor.loadForEditFailed": "編集のためにこの画像をロードできませんでした",
    "imageEditor.canvasCreateFailed": "画像編集キャンバスの作成に失敗しました",
    "imageEditor.closedRegionRequired": "最初にブラシを使用して閉じた領域を描画します",
    "imageEditor.saveFailed": "画像編集を保存できませんでした",
    "imageEditor.saved": "編集された入力画像が保存されました",
    "imageEditor.uneditable": "この画像は編集できません",
    "imageEditor.resetDone": "元のイメージにリセット",
    "imageEditor.resetFailed": "元のイメージをリセットできませんでした",
    "imageEditor.subtitle": "切り抜き、描画、塗りつぶし、または矢印を追加して、新しい入力画像として保存します",
    "imageEditor.toolbar": "画像エディターのツールバー",
    "imageEditor.tools": "ツール",
    "imageEditor.select": "選択",
    "imageEditor.brush": "ブラシ",
    "imageEditor.arrow": "矢印",
    "imageEditor.crop": "作物",
    "imageEditor.fill": "塗りつぶし",
    "imageEditor.fillLabel": "ペイントバケツの充填",
    "imageEditor.eraser": "消しゴム",
    "imageEditor.colors": "色",
    "imageEditor.red": "赤",
    "imageEditor.blue": "ブルー",
    "imageEditor.green": "グリーン",
    "imageEditor.yellow": "黄色",
    "imageEditor.white": "ホワイト",
    "imageEditor.black": "ブラック",
    "imageEditor.customColor": "カスタムカラー",
    "imageEditor.stroke": "太さ",
    "imageEditor.history": "履歴",
    "imageEditor.undo": "元に戻す",
    "imageEditor.redo": "やり直し",
    "imageEditor.reset": "画像をリセット",
    "imageEditor.canvas": "画像編集キャンバス",
    "imageEditor.canvasScope": "キャンバス範囲",
    "imageEditor.canvasScopeBase": "元画像",
    "imageEditor.canvasScopeFit": "レイヤーに合わせる",
    "imageEditor.canvasFitDone": "キャンバスをレイヤー範囲に合わせました",
    "imageEditor.canvasBaseDone": "キャンバスを元画像範囲に戻しました",
    "imageEditor.insertImages": "画像を挿入",
    "imageEditor.layers": "レイヤー",
    "imageEditor.layerUp": "上へ",
    "imageEditor.layerDown": "下へ",
    "imageEditor.emptyInsertList": "ほかの入力画像はありません",
    "imageEditor.selectLayerFirst": "先にレイヤーを選択してください",
    "imageEditor.baseLayer": "元画像",
    "gallery.title": "ギャラリー",
    "gallery.subtitle": "現在のタスクの参照画像を選択してください",
    "gallery.manageCategories": "カテゴリを管理する",
    "gallery.categoryManager": "ギャラリー カテゴリを管理する",
    "gallery.categoryManagement": "カテゴリ管理",
    "gallery.categoryCopy": "カテゴリはギャラリーに保存されます。プロンプトの役割は、参照がどのように使用されるかを説明します。",
    "gallery.newCategoryName": "新しいカテゴリ名",
    "gallery.newCategoryRole": "プロンプトでの用途、例: スタイル参照",
    "gallery.addCategory": "カテゴリを追加",
    "gallery.drawerSubtitle": "現在のカテゴリ:{category}。 「使用」をクリックすると画像入力に追加されます。",
    "gallery.emptyCategory": "このカテゴリにはまだ画像がありません",
    "gallery.dragSort": "ドラッグして並べ替えます",
    "gallery.dragSortImage": "画像をドラッグソート{name}",
    "gallery.dragSortCategory": "ドラッグソートカテゴリ{name}",
    "gallery.use": "使用",
    "gallery.replace": "交換",
    "gallery.rename": "名前を変更",
    "gallery.moveCategory": "カテゴリ",
    "gallery.note": "注",
    "gallery.delete": "削除",
    "gallery.uncategorized": "未分類",
    "addGallery.title": "ギャラリーに追加",
    "addGallery.copy": "名前はグローバルに一意であり、後で @name を使用して参照できます。",
    "addGallery.name": "名前",
    "addGallery.namePlaceholder": "例: ミア",
    "addGallery.category": "カテゴリ",
    "addGallery.note": "参考ノート",
    "addGallery.notePlaceholder": "例: 顔と髪のみを参照し、衣服や背景は参照しない",
    "addGallery.save": "ギャラリーに保存",
    "close.promptTemplates": "プロンプト テンプレート パネルを閉じる",
    "close.archive": "アーカイブ パネルを閉じる",
    "close.settings": "ストレージ設定パネルを閉じる",
    "close.apiSettings": "API設定パネルを閉じる",
    "close.systemSettings": "システム設定パネルを閉じる",
    "close.imageEditor": "画像エディター パネルを閉じる",
    "close.gallery": "ギャラリー パネルを閉じる",
    "close.addGallery": "ギャラリー追加パネルを閉じる",
    "close.version": "バージョン更新パネルを閉じる",
    "imageInput.referenceTitle": "参照入力（任意）",
    "referenceFiles.add": "ファイルを追加",
    "referenceFiles.selected": "参照ファイル",
    "referenceFiles.recent": "最近のファイル",
    "referenceFiles.familyPdf": "ページ + テキスト",
    "referenceFiles.familySpreadsheet": "表計算",
    "referenceFiles.familyDocument": "ドキュメント",
    "referenceFiles.familyText": "テキスト",
    "referenceFiles.visualLimit": "PDF 以外では埋め込み画像やグラフは保持されません。レイアウト参照が必要な場合は PDF に変換してください。",
    "referenceFiles.remove": "{filename} を削除",
    "referenceFiles.switchTitle": "参照ファイルを削除しますか？",
    "referenceFiles.switchMessage": "参照ファイルは Responses でのみ利用できます。Images に切り替える前に選択ファイルを削除してください。",
    "referenceFiles.removeAndSwitch": "ファイルを削除して切り替え",
    "referenceFiles.requiresResponses": "参照ファイルには Responses が必要です",
    "referenceFiles.switchToResponses": "Responses に切り替え",
    "referenceFiles.openApiSettings": "API 設定を開く",
    "referenceFiles.providerMissing": "元の Responses プロバイダーを利用できません。API 設定で選択してください。",
    "referenceFiles.missing": "ファイルがありません",
    "referenceFiles.loadFailed": "参照ファイルを読み込めませんでした",
    "referenceFiles.errorEmpty": "参照ファイルが空です",
    "referenceFiles.errorUnsupported": "この参照ファイル形式はサポートされていません",
    "referenceFiles.errorMismatch": "ファイル内容と拡張子が一致しません",
    "referenceFiles.errorInvalid": "参照ファイルが無効です",
    "referenceFiles.errorTooLarge": "参照ファイルは 1 件 50 MB 未満にしてください",
    "referenceFiles.errorTotalTooLarge": "参照ファイルの合計は 50 MB 以下にしてください",
    "referenceFiles.errorMissing": "選択した参照ファイルがありません",
    "referenceFiles.errorProviderUnsupported": "このプロバイダーの Responses は参照ファイルをサポートしていません",
    "referenceFiles.responsesEnabled": "Responses に切り替えました",
    "referenceFiles.historyPathMismatch": "参照ファイルの Responses パスが異なります",
    "history.referenceFiles": "参照ファイル",
    "history.downloadReferenceFile": "ファイルをダウンロード",
    "history.readdReferenceFile": "再追加",
};
